
import React from 'react';
import { Button } from '@/components/ui/button';
import { PenLine } from 'lucide-react';
import { CycleData } from '@/utils/cycle-tracking';
import { CycleCircle } from './circular/CycleCircle';
import { CircleCenter } from './circular/CircleCenter';
import { PeriodDateDialog } from './circular/PeriodDateDialog';
import { TrackingButtons } from './circular/TrackingButtons';
import { useCircularCycleView } from './circular/useCircularCycleView';

interface CircularCycleViewProps {
  cycleData: CycleData | null;
}

export const CircularCycleView: React.FC<CircularCycleViewProps> = ({ cycleData }) => {
  const {
    isEditDialogOpen,
    setIsEditDialogOpen,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    activeCalendar,
    setActiveCalendar,
    highlightedDay,
    setHighlightedDay,
    handleSavePeriodDate,
  } = useCircularCycleView(cycleData);
  
  if (!cycleData) return null;
  
  return (
    <div className="relative flex flex-col items-center">
      {/* Cycle Circle with phases and day numbers */}
      <div className="relative w-[320px] h-[320px] mb-6">
        <CycleCircle 
          cycleData={cycleData} 
          highlightedDay={highlightedDay} 
          setHighlightedDay={setHighlightedDay} 
        />
        
        {/* Center content */}
        <CircleCenter cycleData={cycleData} highlightedDay={highlightedDay} />
      </div>
      
      {/* Edit Period Button */}
      <Button 
        variant="outline"
        size="lg"
        className="text-hormony-coral border-2 border-hormony-light-coral bg-white mb-6 hover:bg-hormony-light-coral/10 transition-colors"
        onClick={() => setIsEditDialogOpen(true)}
      >
        <PenLine className="w-4 h-4 mr-2" />
        Edit Period
      </Button>
      
      {/* Tracking Buttons */}
      <TrackingButtons cycleData={cycleData} setIsEditDialogOpen={setIsEditDialogOpen} />
      
      {/* Period Date Dialog */}
      <PeriodDateDialog
        isOpen={isEditDialogOpen}
        onOpenChange={setIsEditDialogOpen}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        activeCalendar={activeCalendar}
        setActiveCalendar={setActiveCalendar}
        onSave={handleSavePeriodDate}
      />
    </div>
  );
};
